const experience_cardStyles = {
    marginTop: {
        xs: 11.75,
        sm: 12,
        md: 12.25,
        lg: 12.5,
    },
    marginLeft: {
        xs: 1.75,
        sm: 2,
        md: 2.25,
        lg: 2.5,
    },
    marginRight: {
        xs: 1.75,
        sm: 2,
        md: 2.25,
        lg: 2.5,
    },
    marginBottom: {
        xs: 1.75,
        sm: 2,
        md: 2.25,
        lg: 2.5,
    }
};

export const ExperienceCardStyles = experience_cardStyles;

const jobTitle_styles = {
    fontSize: {
        xs: "2.0rem",
        sm: "2.25rem",
        md: "2.5rem",
        lg: "2.75rem",
    },
    width: 1,
    align: "left",
    ml: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
        lg: "1.5rem"
    }

};

export const JobTitleStyles = jobTitle_styles;

const jobLocation_styles = {
    fontSize: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
        lg: "2rem",
    },
    width: 1,
    align: "left",
    ml: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
        lg: "2.25rem"
    }
};

export const JobLocationStyles = jobLocation_styles;

const jobDescription_styles = {
    align: "left",
    width: {
        xs: "calc(100% - 1.75rem)",
        sm: "calc(100% - 2rem)",
        md: "calc(100% - 2.25rem)",
        lg: "calc(100% - 2.5rem)"
    },
    "& .MuiListItemText-primary": {
        fontSize: {
            xs: "0.75rem",
            sm: "1rem",
            md: "1.25rem",
            lg: "1.5rem"
        }
    },
    "& .MuiListItemText-secondary": {
        fontSize: {
            xs: "0.75rem",
            sm: "1rem",
            md: "1.25rem",
            lg: "1.5rem"
        },
    }
};

export const JobDescriptionStyles = jobDescription_styles;

const jobList_styles = {
    fontSize: {
        xs: "1rem",
        sm: "1.25rem",
        md: "2rem",
        lg: "2rem"
    },
    align: 'left',
    ml: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
        lg: "2.25rem"
    }
}

export const JobListStyles = jobList_styles;

const jobTimeline_styles = {
    fontSize: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
        lg: "2rem",
    },
    width: 1,
    textAlign: 'right',
    mr: {
        xs: "0.75rem",
        sm: "1.0rem",
        md: "1.25rem",
        lg: "1.5rem"
    }
};

export const JobTimelineStyles = jobTimeline_styles;
